import React from 'react';

import { ReactComponent as IconArrowsPointingEdges } from 'media/svg/arrowsPointingEdges.svg';

import { Image } from 'proto/Media/Image';

import styles from '../__partials/Aside/Thumbnail.module.scss';

export const getThumbnailList = (
    image: Image[],
    lastSlideText: string,
    altText?: string,
    handleDragStart?: (e: React.MouseEvent<HTMLDivElement>) => void
) => {
    const imageList = image.map((currentImage, index) => (
        <img
            data-src={currentImage.url}
            key={index}
            alt={altText}
            onDragStart={handleDragStart}
            width={'auto'}
            height={'100%'}
        />
    ));

    imageList.push(
        <div key={image.length + 1} className={styles.LastSlide}>
            {imageList[0]}
            <div className={styles.HotelImgMoreTeaser}>
                <div className={styles.Background} />
                <div className={styles.Content}>
                    <span className={styles.Text}>{lastSlideText}</span>
                    <IconArrowsPointingEdges />
                </div>
            </div>
        </div>
    );

    return imageList;
};

export const forceLazyLoad = () => {
    const imageList = Array.from(
        document.querySelectorAll('.swiper-slide-visible img')
    );

    if (!!imageList.length) {
        imageList.forEach((image) => {
            const dataSrc = image.getAttribute('data-src');
            if (dataSrc) {
                image.setAttribute('src', dataSrc);
            }
        });
    }
};
